import React from 'react'
import Container from '../../Components/Container'
import { useEffect, useState, useMemo, useCallback } from 'react'
import {
    FaArrowUp,
    FaCalendarAlt,
    FaCashRegister,
    FaChartLine,
    FaCoins,
    FaLayerGroup,
    FaRedoAlt,
    FaExclamationTriangle,
    FaBoxOpen,
} from 'react-icons/fa'
import toast, { Toaster } from 'react-hot-toast'
import { IoIosReturnLeft } from 'react-icons/io'
import { MdDelete } from 'react-icons/md'

const todayInputValue = () => {
    const d = new Date()
    const p = (n) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

const Daily = () => {
    const [price, setPrice] = useState(0)
    const [cost, setCost] = useState(0)
    const [total, setTotal] = useState(0)
    const [count, setCount] = useState([0, 0, 0])
    const [cat, setCat] = useState([])
    const [stores, setStores] = useState([])
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [date, setDate] = useState(todayInputValue)
    const [category, setCategory] = useState('')
    const [store, setStore] = useState('')
    const [order, setOrder] = useState(false)

    const [dailyCount, setDailyCount] = useState(0)

    const applyPanelAgg = (rows, errMsg) => {
        if (!Array.isArray(rows) || rows.length === 0) {
            toast.error(errMsg)
            return
        }
        const row = rows[0]
        if (row == null) {
            toast.error(errMsg)
            return
        }
        setPrice(row.price ?? 0)
        setCost(row.cost ?? 0)
        setTotal(row.count ?? 0)
    }

    const fetchData = useCallback(() => {
        setLoading(true)
        const formdata = new FormData()
        formdata.append('action', 'selectDay')
        formdata.append('date', date)
        fetch(process.env.REACT_APP_BASE_URL + 'sales.php', {
            method: 'POST',
            body: formdata,
        })
            .then((res) => {
                if (!res.ok) throw new Error('Sunucu yanıt vermedi')
                return res.json()
            })
            .then((rows) => {
                if (!Array.isArray(rows)) {
                    setData([])
                    setCount([0, 0, 0])
                    setDailyCount(0)
                    toast.error('Beklenmeyen veri formatı')
                    return
                }
                setData(rows)
                const s = rows.filter((i) => Number(i.type) === 1).length
                const r = rows.filter((i) => Number(i.type) === 0).length
                const c = rows.filter((i) => Number(i.type) === 2).length
                setCount([s, r, c])
                setDailyCount(
                    rows.reduce((acc, curr) => acc + Number(curr.count || 0), 0)
                )
            })
            .catch(() => {
                setData([])
                setCount([0, 0, 0])
                setDailyCount(0)
                toast.error('Satış listesi yüklenemedi')
            })
            .finally(() => setLoading(false))
    }, [date])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const displayData = useMemo(() => {
        if (!Array.isArray(data)) return []
        const copy = [...data]
        if (order) copy.reverse()
        return copy
    }, [data, order])

    useEffect(() => {
        const categories = new FormData()
        categories.append('action', 'select')
        fetch(process.env.REACT_APP_BASE_URL + 'categories.php', {
            method: 'POST',
            body: categories,
        })
            .then((res) => res.json())
            .then((rows) => setCat(Array.isArray(rows) ? rows : []))
            .catch(() => toast.error('Kategoriler yüklenemedi'))

        const storesFd = new FormData()
        storesFd.append('action', 'select')
        fetch(process.env.REACT_APP_BASE_URL + 'store.php', {
            method: 'POST',
            body: storesFd,
        })
            .then((res) => res.json())
            .then((rows) => setStores(Array.isArray(rows) ? rows : []))
            .catch(() => toast.error('Depolar yüklenemedi'))
    }, [])

    const filterHandel = (e) => {
        const dataAtt = e.currentTarget.dataset.t
        const allItems = document.querySelectorAll('[data-type]')

        allItems.forEach((item) => {
            const d = item.dataset.type
            if (d !== dataAtt) {
                item.classList.add('hidden')
            } else {
                item.classList.remove('hidden')
            }
        })
    }

    const filterByCategories = (e) => {
        const val = e.target.value
        setCategory(val)

        if (!val) {
            document.querySelectorAll('[data-category]').forEach((item) => {
                item.classList.remove('hidden')
            })
            return
        }

        const formdata = new FormData()
        formdata.append('action', 'selectByCategory')
        formdata.append('date', date)
        formdata.append('store', store)
        formdata.append('category', val)
        fetch(process.env.REACT_APP_BASE_URL + 'panel.php', {
            method: 'POST',
            body: formdata,
        })
            .then((res) => {
                if (!res.ok) throw new Error()
                return res.json()
            })
            .then((rows) =>
                applyPanelAgg(rows, 'Kategori özeti alınamadı')
            )
            .catch(() => toast.error('Kategori özeti alınamadı'))

        const allItems = document.querySelectorAll('[data-category]')

        allItems.forEach((item) => {
            const d = item.dataset.category
            if (d !== val) {
                item.classList.add('hidden')
            } else {
                item.classList.remove('hidden')
            }
        })
    }

    const filterByStore = (e) => {
        const val = e.target.value
        setStore(val)
        setCategory('')

        if (!val) {
            document.querySelectorAll('[data-store]').forEach((item) => {
                item.classList.remove('hidden')
            })
            return
        }

        const formdata = new FormData()
        formdata.append('action', 'selectByStore')
        formdata.append('date', date)
        formdata.append('store', val)
        fetch(process.env.REACT_APP_BASE_URL + 'panel.php', {
            method: 'POST',
            body: formdata,
        })
            .then((res) => {
                if (!res.ok) throw new Error()
                return res.json()
            })
            .then((rows) =>
                applyPanelAgg(rows, 'Depo özeti alınamadı')
            )
            .catch(() => toast.error('Depo özeti alınamadı'))

        const allItems = document.querySelectorAll('[data-store]')

        allItems.forEach((item) => {
            const d = item.dataset.store
            if (d !== val) {
                item.classList.add('hidden')
            } else {
                item.classList.remove('hidden')
            }
        })
    }

    const deleteHandel = (item) => {
        setLoading(true)
        const formdata = new FormData()
        formdata.append('action', 'cancel')
        formdata.append('id', item.id)
        formdata.append('store', item.store)
        formdata.append('barcode', item.barcode)
        formdata.append('count', item.count)
        fetch(process.env.REACT_APP_BASE_URL + 'sales.php', {
            method: 'POST',
            body: formdata,
        })
            .then((res) => {
                if (!res.ok) throw new Error()
                return res.json()
            })
            .then((resData) => {
                if (Number(resData.status) !== 200) {
                    toast.error(resData.message || 'İşlem başarısız')
                } else {
                    fetchData()
                }
            })
            .catch(() => toast.error('Kayıt iptal edilemedi'))
            .finally(() => setLoading(false))
    }

    const returnHandel = (item) => {
        setLoading(true)
        const formdata = new FormData()
        formdata.append('action', 'dailyReturn')
        formdata.append('basket', JSON.stringify(item))
        fetch(process.env.REACT_APP_BASE_URL + 'sales.php', {
            method: 'POST',
            body: formdata,
        })
            .then((res) => {
                if (!res.ok) throw new Error()
                return res.json()
            })
            .then((resData) => {
                if (Number(resData.status) !== 200) {
                    toast.error(resData.message || 'İşlem başarısız')
                } else {
                    fetchData()
                }
            })
            .catch(() => toast.error('İade işlemi başarısız'))
            .finally(() => setLoading(false))
    }

    const fmt = (n) =>
        Number(n || 0).toLocaleString('tr-TR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        })

    const typeMeta = (t) => {
        if (t === 1)
            return {
                label: 'Satış',
                pill: 'bg-indigo-100 text-indigo-800 ring-indigo-200/60',
            }
        if (t === 0)
            return {
                label: 'İade',
                pill: 'bg-red-100 text-red-800 ring-red-200/60',
            }
        return {
            label: 'Zaiat',
            pill: 'bg-amber-100 text-amber-900 ring-amber-200/60',
        }
    }

    return (
        <Container padding bg="#f8fafc">
            <Toaster
                position="top-right"
                toastOptions={{
                    className: 'text-sm font-medium shadow-lg',
                }}
            />

            <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-16 space-y-6">
                {/* Başlık */}
                <div className="rounded-2xl border border-slate-200/80 bg-white p-6 sm:p-8 shadow-sm shadow-slate-200/50">
                    <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
                        <div className="flex items-start gap-4">
                            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-md shadow-indigo-500/25">
                                <FaCashRegister className="text-xl" />
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                                    Günlük satışlar
                                </h1>
                                <p className="mt-1 text-sm text-slate-600 leading-relaxed max-w-xl">
                                    Seçilen güne ait hareketleri inceleyin; depo ve
                                    kategoriye göre özet alın.
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                            <label className="flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50/90 px-3 py-2 shadow-sm">
                                <FaCalendarAlt className="text-slate-400 shrink-0" />
                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    className="bg-transparent text-sm font-medium text-slate-900 outline-none min-w-[10rem]"
                                />
                            </label>
                            {loading && (
                                <span className="text-xs font-medium text-indigo-600 px-2 py-1 rounded-lg bg-indigo-50">
                                    Yenileniyor…
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                {/* Adet özeti */}
                {data.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        {[
                            {
                                val: dailyCount,
                                title: 'Toplam adet',
                                sub: 'Tüm işlem satırlarındaki adet toplamı',
                                icon: FaLayerGroup,
                                accent:
                                    'from-indigo-500/10 to-violet-500/5 text-indigo-700 ring-indigo-200/50',
                            },
                            {
                                val: count[1] ?? 0,
                                title: 'İade kayıtları',
                                sub: 'İade işlemi sayısı',
                                icon: FaRedoAlt,
                                accent:
                                    'from-red-500/10 to-rose-500/5 text-red-700 ring-red-200/50',
                            },
                            {
                                val: count[2] ?? 0,
                                title: 'Zaiat kayıtları',
                                sub: 'Zaiat işlemi sayısı',
                                icon: FaExclamationTriangle,
                                accent:
                                    'from-amber-500/15 to-yellow-500/5 text-amber-900 ring-amber-200/60',
                            },
                        ].map((card, i) => (
                            <div
                                key={i}
                                className={`rounded-2xl border border-slate-200/80 bg-gradient-to-br ${card.accent} p-5 shadow-sm ring-1`}
                            >
                                <div className="flex items-center gap-3">
                                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/80 shadow-sm">
                                        <card.icon className="text-lg" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-semibold uppercase tracking-wide text-slate-600">
                                            {card.title}
                                        </p>
                                        <p className="text-2xl font-bold tabular-nums text-slate-900">
                                            {card.val}
                                        </p>
                                    </div>
                                </div>
                                <p className="mt-3 text-xs text-slate-600 leading-snug">
                                    {card.sub}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                {/* Tutar özeti */}
                {data.length > 0 && (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        {[
                            {
                                label: 'Ciro (satış)',
                                value: fmt(price),
                                suffix: '₺',
                                icon: FaChartLine,
                                color: 'text-indigo-600',
                                bg: 'bg-indigo-50',
                            },
                            {
                                label: 'Maliyet',
                                value: fmt(cost),
                                suffix: '₺',
                                icon: FaCoins,
                                color: 'text-red-600',
                                bg: 'bg-red-50',
                            },
                            {
                                label: 'Özet adet',
                                value: fmt(total),
                                suffix: null,
                                icon: FaBoxOpen,
                                color: 'text-amber-700',
                                bg: 'bg-amber-50',
                            },
                        ].map((row, i) => (
                            <div
                                key={i}
                                className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm flex items-center gap-4"
                            >
                                <div
                                    className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${row.bg}`}
                                >
                                    <row.icon className={`text-xl ${row.color}`} />
                                </div>
                                <div>
                                    <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
                                        {row.label}
                                    </p>
                                    <p
                                        className={`text-xl font-bold tabular-nums ${row.color}`}
                                    >
                                        {row.value}
                                        {row.suffix && (
                                            <>
                                                {' '}
                                                <span className="text-sm font-semibold">
                                                    {row.suffix}
                                                </span>
                                            </>
                                        )}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* İşlem tipi filtresi */}
                {data.length > 0 && (
                    <div className="rounded-2xl border border-slate-200/80 bg-white p-4 sm:p-5 shadow-sm">
                        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-3">
                            Listeyi işlem tipine göre daralt
                        </p>
                        <div className="flex flex-col sm:flex-row gap-2 p-1 rounded-xl bg-slate-100">
                            {[
                                { t: '1', label: 'Satış', style: 'bg-white text-indigo-700 shadow-sm ring-1 ring-slate-200/80' },
                                { t: '0', label: 'İade', style: 'bg-white text-red-700 shadow-sm ring-1 ring-slate-200/80' },
                                { t: '2', label: 'Zaiat', style: 'bg-white text-amber-800 shadow-sm ring-1 ring-slate-200/80' },
                            ].map((b) => (
                                <button
                                    key={b.t}
                                    type="button"
                                    onClick={(e) => filterHandel(e)}
                                    data-t={b.t}
                                    className={`flex-1 py-3 rounded-lg text-sm font-semibold transition-colors hover:opacity-95 ${b.style}`}
                                >
                                    {b.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                {/* Depo / kategori */}
                {data.length > 0 && (
                    <div className="rounded-2xl border border-slate-200/80 bg-white p-4 sm:p-5 shadow-sm">
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex-1">
                                <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
                                    Depo
                                </label>
                                <select
                                    value={store}
                                    onChange={filterByStore}
                                    className="w-full rounded-xl border border-slate-200 bg-slate-50/80 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                                >
                                    <option value="">Tüm depolar / seçiniz</option>
                                    {stores.map((st, idx) => (
                                        <option value={st.name} key={idx}>
                                            {st.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {store !== '' && (
                                <div className="flex-1">
                                    <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
                                        Kategori
                                    </label>
                                    <select
                                        value={category}
                                        onChange={filterByCategories}
                                        className="w-full rounded-xl border border-slate-200 bg-slate-50/80 px-3.5 py-2.5 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20"
                                    >
                                        <option value="">Kategori seçiniz</option>
                                        {cat.map((c, idx) => (
                                            <option value={c.name} key={idx}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <p className="text-sm text-slate-600">
                        {displayData.length} kayıt
                        {data.length > 0 && ' · Tarih için liste'}
                    </p>
                    <button
                        type="button"
                        onClick={() => setOrder(!order)}
                        className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                    >
                        {order ? 'En yeni önce' : 'En eski önce'}
                        <FaArrowUp
                            className={`transition-transform duration-200 ${order ? '' : 'rotate-180'}`}
                        />
                    </button>
                </div>

                {/* Kart grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
                    {loading ? (
                        <div className="col-span-full flex flex-col items-center justify-center py-24 rounded-2xl border border-dashed border-slate-200 bg-white">
                            <div className="h-10 w-10 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
                            <p className="mt-4 text-sm font-medium text-slate-600">
                                Yükleniyor…
                            </p>
                        </div>
                    ) : displayData.length === 0 ? (
                        <div className="col-span-full rounded-2xl border border-dashed border-slate-200 bg-white px-6 py-16 text-center">
                            <FaCashRegister className="mx-auto text-4xl text-slate-300 mb-4" />
                            <p className="text-base font-semibold text-slate-800">
                                Bu tarihte kayıt yok
                            </p>
                            <p className="mt-2 text-sm text-slate-600">
                                Başka bir gün seçin veya satış ekleyin.
                            </p>
                        </div>
                    ) : (
                        displayData.map((item, idx) => {
                            const t = Number(item.type)
                            const meta = typeMeta(t)
                            return (
                                <div
                                    key={idx}
                                    className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm shadow-slate-200/40 transition hover:shadow-md hover:border-slate-300/90"
                                    data-type={t}
                                    data-store={item.store}
                                    data-category={item.category}
                                >
                                    <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                                        <img
                                            src={
                                                item.image ||
                                                'https://placehold.co/600x400/e2e8f0/64748b?text=Ürün'
                                            }
                                            className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
                                            alt=""
                                        />
                                        <span
                                            className={`absolute top-3 left-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${meta.pill}`}
                                        >
                                            {meta.label}
                                        </span>
                                    </div>
                                    <div className="flex flex-1 flex-col p-4">
                                        <h2 className="font-semibold text-slate-900 line-clamp-2 leading-snug">
                                            {item.name}
                                        </h2>
                                        <p className="mt-1 text-xs text-slate-500 font-mono">
                                            {item.barcode}
                                        </p>
                                        <p className="mt-3 text-lg font-bold tabular-nums text-indigo-600">
                                            {parseFloat(item.price).toLocaleString(
                                                'tr-TR',
                                                {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                }
                                            )}{' '}
                                            <span className="text-sm font-semibold text-indigo-500">
                                                ₺
                                            </span>
                                        </p>
                                        <div className="mt-3 flex flex-wrap gap-2 text-xs text-slate-600">
                                            <span className="rounded-lg bg-slate-100 px-2 py-1 font-medium">
                                                {item.count} adet
                                            </span>
                                            <span className="rounded-lg bg-slate-100 px-2 py-1">
                                                {item.user}
                                            </span>
                                        </div>
                                        <p className="mt-2 text-xs text-slate-400">
                                            {item.date}
                                        </p>
                                        <div className="mt-auto flex flex-col gap-2 pt-4">
                                            {t === 0 && (
                                                <span className="w-full rounded-xl bg-red-600 py-2 text-center text-sm font-bold text-white">
                                                    İade kaydı
                                                </span>
                                            )}
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        deleteHandel(item)
                                                    }
                                                    className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-red-500 py-2.5 text-sm font-semibold text-white transition hover:bg-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                                                >
                                                    <MdDelete size={18} />
                                                    Sil
                                                </button>
                                                {t !== 0 && (
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            returnHandel(item)
                                                        }
                                                        className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-indigo-600 py-2.5 text-sm font-semibold text-white transition hover:bg-indigo-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                                                    >
                                                        <IoIosReturnLeft size={18} />
                                                        İade
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}
                </div>
            </div>
        </Container>
    )
}

export default Daily
